export var DoghouseCategory;
(function (DoghouseCategory) {
    DoghouseCategory[DoghouseCategory["GiveDoghouseBone"] = 18] = "GiveDoghouseBone";
    DoghouseCategory[DoghouseCategory["GiveDoghouseBonePrm"] = 30] = "GiveDoghouseBonePrm";
})(DoghouseCategory || (DoghouseCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/DoghouseCategory.ts
// module id = 345
// module chunks = 3